import "./WhyChooseUs.css";

export default function WhyChooseUs() {
  const features = [
    {
      title: "SKILLED CHEF",
      img: "https://images.unsplash.com/photo-1556912998-c57cc6b63cd7"
    },
    {
      title: "HYGIENIC FOOD",
      img: "https://images.unsplash.com/photo-1556912998-c57cc6b63cd7"
    },
    {
      title: "FRESH AMBIENCE",
      img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836"
    },
    {
      title: "SECRET RECIPE",
      img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836"
    }
  ];

  const stats = [
    { number: "600+", label: "MONTHLY VISITORS" },
    { number: "450+", label: "POSITIVE REVIEWS" },
    { number: "135+", label: "SECRET RECIPE" },
    { number: "25+", label: "AWARD & HONOURS" }
  ];

  return (
    <section className="wc-section">
      <p className="wc-subtitle">★ WHY CHOOSE US ★</p>
      <h1 className="wc-title">Why Dine With Us</h1>

      {/* FEATURE IMAGES */}
      <div className="wc-features">
        {features.map((item, i) => (
          <div className="wc-feature-card" key={i}>
            <div className="wc-img-wrapper">
              <img src={item.img} alt={item.title} />
            </div>
            <p className="wc-feature-title">{item.title}</p>
          </div>
        ))}
      </div>

      {/* STATS BLOCK */}
      <div className="wc-stats">
        {stats.map((item, i) => (
          <div className="wc-stat-card" key={i}>
            <h2 className="wc-stat-number">{item.number}</h2>
            <p className="wc-stat-label">{item.label}</p>
            <p className="wc-stat-desc">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has been.
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
